<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27942_39715)">
      <mask
        id="mask0_27942_39715"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path d="M20 0H0V20H20V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_27942_39715)">
        <path
          d="M3.8832 19.2337C3.54154 19.2337 3.2582 19.0004 3.19154 18.6754L2.99987 17.8587C2.91654 17.5004 2.6332 17.2171 2.2832 17.1337L1.4582 16.9421C1.1332 16.8754 0.908203 16.5837 0.908203 16.2504C0.908203 15.9087 1.14154 15.6254 1.47487 15.5587L2.2832 15.3671C2.64154 15.2837 2.92487 15.0004 3.0082 14.6504L3.19987 13.8254C3.26654 13.5087 3.5582 13.2754 3.89154 13.2754C4.2332 13.2754 4.51654 13.5087 4.5832 13.8337L4.77487 14.6504C4.8582 15.0087 5.14154 15.2921 5.49154 15.3754L6.31654 15.5671C6.6332 15.6337 6.86654 15.9254 6.86654 16.2587C6.86654 16.5921 6.64154 16.8837 6.31654 16.9504L5.49154 17.1421C5.1332 17.2254 4.84987 17.5087 4.76654 17.8587L4.57487 18.6837C4.5082 19.0004 4.21654 19.2337 3.8832 19.2337ZM3.31654 16.2587C3.54154 16.4087 3.7332 16.6087 3.8832 16.8254C4.0332 16.6004 4.22487 16.4087 4.44987 16.2587C4.22487 16.1087 4.0332 15.9087 3.8832 15.6921C3.7332 15.9087 3.54154 16.1087 3.31654 16.2587Z"
          fill="#667085"
        />
        <path
          d="M7.56745 9.68366C5.18136 9.68366 3.17578 7.77983 3.17578 5.36699C3.17578 3.02533 5.11745 1.04199 7.50078 1.04199C9.88411 1.04199 11.8258 2.98366 11.8258 5.36699C11.8175 7.67477 9.88736 9.68366 7.56745 9.68366ZM7.50078 2.29199C5.80911 2.29199 4.42578 3.67533 4.42578 5.36699C4.42578 7.07674 5.81073 8.41916 7.50078 8.42741C9.17928 8.43566 10.5673 7.04932 10.5758 5.36699C10.5758 3.67533 9.19245 2.29199 7.50078 2.29199Z"
          fill="#667085"
        />
        <path
          d="M13.809 9.80012C13.4756 9.83346 13.0173 9.58346 12.984 9.24179C12.9506 8.90012 13.159 8.59179 13.5006 8.55012C13.697 8.53379 13.8865 8.55237 14.0819 8.51754C15.1606 8.32509 15.9673 7.38731 15.9673 6.25846C15.9673 5.03346 14.9423 3.9668 13.6756 3.9668C13.334 3.9668 13.0506 3.68346 13.0506 3.3418C13.0506 3.00013 13.334 2.7168 13.6756 2.7168C15.6256 2.7168 17.2173 4.30846 17.2173 6.25846C17.2173 8.20846 15.7173 9.72512 13.809 9.80012C13.8474 9.80012 13.775 9.80012 13.809 9.80012Z"
          fill="#667085"
        />
        <path
          d="M7.64195 18.8085C7.59195 18.8085 7.54195 18.8002 7.49195 18.8002C7.15028 18.8002 6.87528 18.5085 6.87528 18.1669C6.87528 17.8252 7.19195 17.5669 7.50861 17.5502C8.9836 17.5752 10.4336 17.1919 11.4586 16.5085C12.2586 15.9752 12.6919 15.2919 12.6919 14.5752C12.6919 13.8669 12.2503 13.1835 11.4586 12.6585C10.4336 11.9752 9.00027 11.5919 7.50861 11.6169C6.73361 11.6335 5.95861 11.7502 5.26695 11.9752C4.97528 12.0669 4.70028 12.1752 4.44195 12.3002C4.13361 12.4502 3.75861 12.3169 3.60861 12.0085C3.45861 11.7002 3.59195 11.3252 3.90028 11.1752C4.20861 11.0252 4.54195 10.8919 4.88361 10.7835C5.70028 10.5252 6.57528 10.3835 7.48361 10.3669C9.25861 10.3252 10.9003 10.7835 12.1503 11.6169C13.3003 12.3835 13.9419 13.4335 13.9419 14.5752C13.9419 15.7169 13.3086 16.7752 12.1503 17.5502C10.9336 18.3585 9.34194 18.8085 7.64195 18.8085Z"
          fill="#667085"
        />
        <path
          d="M15.2825 17.2922C14.9908 17.2922 14.7325 17.0922 14.6742 16.7922C14.6075 16.4505 14.8242 16.1255 15.1575 16.0505C15.6825 15.9422 16.1658 15.7339 16.5408 15.4422C17.0158 15.0839 17.2742 14.6339 17.2742 14.1589C17.2742 13.6839 17.0158 13.2339 16.5492 12.8755C16.1825 12.5922 15.7242 12.3922 15.1825 12.2672C14.8492 12.1922 14.6325 11.8589 14.7075 11.5172C14.7825 11.1839 15.1158 10.9672 15.4575 11.0422C16.1742 11.2005 16.7992 11.4839 17.3075 11.8755C18.0825 12.4589 18.5242 13.2839 18.5242 14.1505C18.5242 15.0172 18.0742 15.8422 17.2992 16.4255C16.9462 16.6989 16.5308 16.9216 16.0746 17.0805C15.8412 17.1617 15.5337 17.2922 15.2825 17.2922Z"
          fill="#667085"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_27942_39715">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "TIIcon",
};
</script>
